import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalDataLoadingSpinner = ({
  tooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.fetchingApprovalDataTooltip"
  })
}) => /*#__PURE__*/_jsx(Flex, {
  inlineSize: "120px",
  justifyContent: "center",
  children: /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipTitle,
    children: /*#__PURE__*/_jsx(LoadingSpinner, {})
  })
});